import { render, staticRenderFns } from "./FertilizerSellerCard.vue?vue&type=template&id=6e008a73&scoped=true&"
import script from "./FertilizerSellerCard.vue?vue&type=script&lang=js&"
export * from "./FertilizerSellerCard.vue?vue&type=script&lang=js&"
import style0 from "./FertilizerSellerCard.vue?vue&type=style&index=0&id=6e008a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e008a73",
  null
  
)

export default component.exports